import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Stack, DefaultButton, PrimaryButton } from '@fluentui/react';
import { SIGN_IN_BUTTON_KEY, SIGN_UP_BUTTON_KEY } from './constants.esm.js';
import { useBreakpoint } from '@agoras/hooks';
import { useTranslation } from 'react-i18next';
import logger from '@agoras/logger';
import { headerContext } from '../../../context.esm.js';
import { useContext, useCallback } from 'react';
import { AppContext } from '../../../../context/context.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var SPLIT_BUTTON_WIDTH = 116;
var splitButtonStyles = {
    splitButtonContainer: {
        width: SPLIT_BUTTON_WIDTH
    }
};
var LoginButtons = function() {
    var _useContext = useContext(AppContext), openSignInModal = _useContext.openSignInModal, onSignUp = _useContext.onSignUp;
    var _useBreakpoint = _sliced_to_array(useBreakpoint('xxxl'), 1), isXXXL = _useBreakpoint[0];
    var t = useTranslation('header').t;
    var signInButtonText = t('Sign in');
    var signUpButtonText = t('Sign up');
    var splitButtonAriaLabel = t('Other login options');
    var splitButtonAriaRoleDecription = t('Login split button');
    var handleSignIn = useCallback(function() {
        logger.info('', _object_spread({
            action: 'SignIn',
            actionModifier: 'Open login modal'
        }, headerContext));
        openSignInModal === null || openSignInModal === void 0 ? void 0 : openSignInModal();
    }, [
        openSignInModal
    ]);
    var handleSignUp = useCallback(function() {
        logger.info('', _object_spread({
            action: 'SignUp',
            actionModifier: 'Click'
        }, headerContext));
        onSignUp === null || onSignUp === void 0 ? void 0 : onSignUp();
    }, [
        onSignUp
    ]);
    var menuProps = {
        isBeakVisible: false,
        styles: {
            container: {
                width: SPLIT_BUTTON_WIDTH
            }
        },
        items: [
            {
                key: SIGN_IN_BUTTON_KEY,
                text: signInButtonText,
                onClick: handleSignIn
            },
            {
                key: SIGN_UP_BUTTON_KEY,
                text: signUpButtonText,
                onClick: handleSignUp
            }
        ]
    };
    return /*#__PURE__*/ jsx(Stack, {
        horizontal: true,
        tokens: {
            childrenGap: 12
        },
        children: isXXXL ? /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx(DefaultButton, {
                    text: signUpButtonText,
                    onClick: handleSignUp,
                    allowDisabledFocus: true
                }),
                /*#__PURE__*/ jsx(PrimaryButton, {
                    text: signInButtonText,
                    onClick: handleSignIn,
                    allowDisabledFocus: true
                })
            ]
        }) : /*#__PURE__*/ jsx(DefaultButton, {
            split: true,
            role: "link",
            text: signInButtonText,
            splitButtonAriaLabel: splitButtonAriaLabel,
            "aria-roledescription": splitButtonAriaRoleDecription,
            menuProps: menuProps,
            ariaLabel: signInButtonText,
            onClick: handleSignIn,
            styles: splitButtonStyles
        })
    });
};

export { LoginButtons as default };
